/**
 * Ticket Lifecycle dashboard tab — gated by LaunchDarkly `ticket-lifecycle`
 * (and camelCase / bracket variants commonly returned by `useFlags()`).
 */

export function isTicketLifecycleLdEnabled(
  flags: Record<string, unknown> | undefined
): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  const f = flags as Record<string, unknown>;
  return (
    f.ticketLifecycle === true ||
    f.ticketlifecycle === true ||
    f["ticket-lifecycle"] === true
  );
}
